export default __webpack_public_path__ + "static/media/map_icon.24f819d6.webp";